import axios from 'axios';
import api from 'src/axiosConfig';

export const APIkey = process.env.REACT_APP_HOSTNAME;
export const APIkeyV2 = process.env.REACT_APP_HOSTNAME_v2;

export const submitQuery = async (newData) => {
  try {
    const { data } = await axios.post(`${APIkeyV2}/website/queries`, newData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return data;
  } catch (err) {
    throw new Error(
      err.response?.data?.message ||
        'An error occurred while submitting the query.'
    );
  }
};

export const getRMList = async () => {
  try {
    const { data } = await axios.get(
      `${APIkeyV2}/users/internal-users/all/SALES`,
      {
        withCredentials: true
      }
    );
    return data;
  } catch (err) {
    throw Error(err?.response?.data?.message);
  }
};

export const registerEPC = async (payload) => {
  try {
    const { data } = await axios.post(`${APIkeyV2}/epc/onboard`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return data;
  } catch (err) {
    throw new Error(err.response?.data?.message);
  }
};

export const verifyPanOnBoarding = async (payload) => {
  try {
    const { data } = await axios.post(
      `${APIkeyV2}/epc/onboard/verify-pan`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return data;
  } catch (err) {
    throw new Error(err.response?.data?.message);
  }
};

export const getManufacturersList = async () => {
  try {
    const { data } = await axios.get(`${APIkeyV2}/manufacturers/list`, {
      withCredentials: true
    });
    return data;
  } catch (err) {
    throw new Error(err.response?.data?.message);
  }
};

export const logout = async () => {
  try {
    const data = await api.get(`${APIkey}/user/logout`);
    return data;
  } catch (err) {
    throw Error(err.response?.data?.message || 'Logout failed');
  }
};

export const login = async (payload) => {
  try {
    const { data } = await api.post(`${APIkey}/user/login`, payload);
    return data;
  } catch (err) {
    throw Error(err.response?.data?.message || 'Login failed');
  }
};

export const generateHypothecationAPIs = async (applicationCode) => {
  try {
    const { data } = await axios.post(
      `${APIkeyV2}/admin/applications/hypothecation-generate?applicationCode=${applicationCode}`,
      {
        withCredentials: true
      }
    );
    return data;
  } catch (err) {
    throw Error(err?.response?.data?.message);
  }
};

export const getRedirectionLink = async () => {
  try {
    const { data } = await axios.get(`${APIkeyV2}/customer/los/login`, {
      withCredentials: true
    });
    return data;
  } catch (err) {
    throw Error(err.response.data.message);
  }
};

export const getCitiesByPincode = async (payload) => {
  try {
    const { data } = await axios.post(
      `${APIkey}/fields/filterCityByPincode`,
      payload,
      {
        withCredentials: true
      }
    );
    return data;
  } catch (err) {
    throw Error(err?.response?.data?.message);
  }
};

export const downloadApplicationDocumentAPI = async ({
  userRole = null,
  applicationCode = null,
  documentType = null
}) => {
  try {
    const { data } = await axios.get(
      `${APIkeyV2}/${userRole}/applications/${applicationCode}/documents/${documentType}`,
      { withCredentials: true }
    );
    return data;
  } catch (err) {
    throw Error(err.response.data.message);
  }
};

export const downloadProposalsDocumentAPI = async ({
  userRole = null,
  proposalId = null,
  documentType = null
}) => {
  try {
    const { data } = await axios.get(
      `${APIkeyV2}/${userRole}/applications/proposals/${proposalId}/documents/${documentType}`,
      { withCredentials: true }
    );
    return data;
  } catch (err) {
    throw Error(err.response.data.message);
  }
};

export const getCustomerApplicationDetailsAPI = async (
  userCode = null,
  userTypeEnum = null
) => {
  try {
    const data = await axios.get(
      `${APIkeyV2}/loan-application/get-customer-application-details?userCode=${userCode}&userTypeEnum=${userTypeEnum}`,
      {
        withCredentials: true
      }
    );
    return data;
  } catch (err) {
    throw Error(err?.response?.data?.message || 'Oops something went wrong!');
  }
};

export const createApplicationAndSentToCustomerAPI = async (
  userCode = null,
  userTypeEnum = null,
  payload = {}
) => {
  try {
    const data = await axios.post(
      `${APIkeyV2}/loan-application/send-to-customer?userCode=${userCode}&userTypeEnum=${userTypeEnum}`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    return data;
  } catch (err) {
    throw Error(err?.response?.data?.message || 'Oops something went wrong!');
  }
};

export const getLoanApplicationDetailsAPI = async () => {
  try {
    const data = await axios.get(`${APIkeyV2}/loan-application`, {
      withCredentials: true
    });
    return data;
  } catch (err) {
    throw Error(err?.response?.data?.message || 'Oops something went wrong!');
  }
};

export const downloadProjectDocumentAPI = async ({
  userRole = null,
  projectCode = null,
  documentType = null
}) => {
  try {
    const { data } = await axios.get(
      `${APIkeyV2}/${userRole}/projects/${projectCode}/documents/${documentType}`,
      { withCredentials: true }
    );
    return data;
  } catch (err) {
    throw Error(err.response.data.message);
  }
};

export const loginByMobile = async (payload) => {
  try {
    const { data } = await axios.post(
      `${APIkey}/user/login/otp/trigger`,
      payload,
      {
        withCredentials: true
      }
    );
    return data;
  } catch (err) {
    throw Error(err.response.data.message);
  }
};

export const verifyMobileOtpForLogin = async (payload) => {
  try {
    const { data } = await axios.post(
      `${APIkey}/user/login/otp/validate`,
      payload,
      {
        withCredentials: true
      }
    );
    return data;
  } catch (err) {
    throw Error(err.response.data.message);
  }
};

export const sendWhatsAppMessageAPI = async ({
  whatsAppNumber,
  userName = 'Solfin',
  templateParams = 'quick support'
}) => {
  try {
    const { data } = await axios.post(
      `${APIkeyV2}/customer-support/send-whatsapp`,
      {
        whatsappNumber: whatsAppNumber,
        userName,
        templateParams: [templateParams]
      }
    );
    return data;
  } catch (error) {
    return { success: false, error };
  }
};

export const fetchDraftEPCData = async (phoneNumber) => {
  try {
    const { data } = await axios.get(
      `${APIkeyV2}/epc/onboard/draft-epc/${phoneNumber}`,
      {
        withCredentials: true
      }
    );

    return data;
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const createPllLeads = async (payload) => {
  try {
    const { data: response } = await axios.post(
      `${APIkeyV2}/pll/create`,
      payload
    );
    return response;
  } catch (err) {
    throw Error(
      err.response?.data?.message ||
        'Failed to create PLL leads! Please try again.'
    );
  }
};

export const getAllWaareeManufacturers = async () => {
  try {
    const { data } = await axios.post(
      `${APIkeyV2}/manufacturer/epc/all-waaree-manufacturer`,
      {
        withCredentials: true
      }
    );
    return data?.data || [];
  } catch (err) {
    throw Error(
      err.response?.data?.message ||
        'Failed to fetch Waaree manufacturers. Please try again.'
    );
  }
};

export const updateManufacturersConsent = async (payload) => {
  try {
    const { data } = await axios.post(
      `${APIkeyV2}/manufacturers-consent`,
      payload,
      {
        withCredentials: true
      }
    );
    return data || [];
  } catch (err) {
    throw Error(
      err.response?.data?.message ||
        'Failed to fetch Waaree manufacturers. Please try again.'
    );
  }
};
